import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { UtentiContext, UtentiProvider } from './UtentiContext';
import { UtentiList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo,
    } = useContext(NavContext);

    const {

        isLoadingUtenti,
        getUtentiAsync,

        isDeletingUtente,
        deleteUtenteAsync,

    } = useContext(UtentiContext)

    const loadMoreHandler = async (pageIndex, pageSize, searchText) => {
        await getUtentiAsync(pageIndex, pageSize, searchText);
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingUtenti || isDeletingUtente);
    }, [isLoadingUtenti, isDeletingUtente]);

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const utentiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.UtenteAdd, "_blank").focus();
                break;
            case "Delete":
                await deleteUtenteAsync(data.id);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (user)
            addBreadcrumbToken("Utenti");
    }, [user]);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            onSearchClick={searchClickHandler}
                            search
                            title="Utenti"
                            subtitle="Gestisci gli utenti" />
                    </Grid>
                    <Grid item xs={12}>
                        <UtentiList
                            searchText={searchText}
                            itemsPerPage={25}
                            onLoadMore={loadMoreHandler}
                            disabled={isLoading}
                            onActionClick={utentiListActionClickHandler} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const UtentiPage = () => {

    return (
        <UtentiProvider>
            <PageContent />
        </UtentiProvider>
    );
}